import useRegionsListQuery from 'common/api/queries/useRegionsListQuery'
import { useAppSelector } from 'common/hooks/redux'

const Region = () => {
  const regionId = useAppSelector((state) => state.styleGuide.regionId)
  const { data: regionsData } = useRegionsListQuery()

  const regionName = regionsData?.find(({ id }) => id === regionId)?.name ?? ''

  return (
    <p className="text-gold-700 text-sm px-6 mt-4">{`Region: ${regionName}`}</p>
  )
}

export default Region
